export enum BusinessAndPeopleSectionType {
    BorrowerEntities = 0,
    OwnersOfBorrowerEntities = 1,
    OwnersOfOtherEntities = 2,
    S1Uploads = 3,
    AdditionalPeople = 4,
    GeneralContractors = 5,
    VerifyCompanyStructure = 6,
    LicenseToBuild = 7,
    References = 8,
    Experience = 9,
}
